import { SubTopic } from "../../models/SubTopic";
import { UPSERT_SUBTOPICS } from "./actionTypes";

export const upsertSubTopics = (subTopics: Array<SubTopic>) => {
    return {
        type: UPSERT_SUBTOPICS,
        payload: subTopics
    };
};